import { render, staticRenderFns } from "./HelloTypescript.vue?vue&type=template&id=5b35fd86&"
import script from "./HelloTypescript.vue?vue&type=script&lang=ts&"
export * from "./HelloTypescript.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports